const modelList = [
	{
		id: 9,
		name: "GPT-Image-2",
		description: "超强图片编辑",
	},
	{
		id: 11,
		name: "GPT-Image-2思考模式",
		description: "细节处理较好",
	},
	{
		id: 10,
		name: "Nano Banana",
		description: "超强图片编辑",
	},
	// {
	// 	id: 1,
	// 	name: "Nano Banana 2.5",
	// 	description: "超强图片编辑",
	// },
	// {
	// 	id: 2,
	// 	name: "Nano Banana 3 ",
	// 	description: "超强图片编辑",
	// },
	// {
	// 	id: 3,
	// 	name: "Nano Banana 3.1",
	// 	description: "支持中文和4K分辨率",
	// },
	// {
	// 	id: 4,
	// 	name: "Nano Banana",
	// 	description: "备用节点",

	// }
]


export default {
	modelList
}